export interface IAddSync {
  batchId: string;
  name: string;
  type: SyncType;
  syncData: ISyncData[];
}

export interface ISyncData {
  field: string;
  dataType: SyncDataType;
  value?: string;
}

export enum SyncType {
  TechAttendanceOn,
  TechAttendanceOff,
  TechLabourOn,
  TechLabourOff,
  TechLabourOnAdhoc,
  TechLabourOffAdhoc
}

export enum SyncDataType {
  Number,
  Text,
  Date
}
